import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Common/Modal'; // Assurez-vous que le chemin est correct
import UseCaseForm from './UseCaseForm';
import { UseCaseDetail } from '../../types';

interface UseCaseFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: UseCaseDetail) => void;
  useCaseToEdit?: UseCaseDetail;
}

const UseCaseFormModal: React.FC<UseCaseFormModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  useCaseToEdit,
}) => {
  const { t } = useTranslation();
  const title = useCaseToEdit
    ? t('useCases.formModal.editTitle', { name: useCaseToEdit.name })
    : t('useCases.formModal.addTitle');

  // Clé pour forcer le re-montage du formulaire lors du changement de useCaseToEdit
  // Cela garantit que react-hook-form réinitialise correctement les defaultValues
  const formKey = useCaseToEdit ? `edit-${useCaseToEdit.id}` : 'add-new';

  return (
    <Modal open={isOpen} onClose={onClose} title={title}>
      <div className="mt-4">
        {/* Utilisation de la clé pour garantir la réinitialisation */}
        <UseCaseForm
          key={formKey}
          onSubmit={onSubmit}
          initialData={useCaseToEdit}
        />
      </div>
    </Modal>
  );
};

export default UseCaseFormModal;
